var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.75H19.1156L16.8737 8.50875L17.75 7.625L21.5 11.375L17.75 15.125L16.8737 14.2406L19.1137 12H11.5C10.5054 12 9.55161 12.3951 8.84835 13.0983C8.14509 13.8016 7.75 14.7554 7.75 15.75C7.75 16.7446 8.14509 17.6984 8.84835 18.4017C9.55161 19.1049 10.5054 19.5 11.5 19.5H16.5V20.75H11.5C10.1739 20.75 8.90215 20.2232 7.96447 19.2855C7.02678 18.3479 6.5 17.0761 6.5 15.75C6.5 14.4239 7.02678 13.1521 7.96447 12.2145C8.90215 11.2768 10.1739 10.75 11.5 10.75Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.7eec92e780ffa50945be6b50847711f1.svg";
export { ForwardRef as ReactComponent };